<form [formGroup]="form1" (ngSubmit)="update()">
    <div class="card">
      <div class="card-header text-center" style="text-transform: uppercase">
        EDITAR VISITANTE
      </div>
      <div class="card-body">
        <div class="row gx-3 mb-3">
          <div class="col-md-4 col-sm-12">
            <label class="small mb-1" for="name">Nombre</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="name" uppercaseInput />
            </div>
          </div>
          <div class="col-md-8 col-sm-12">
            <label class="small mb-1" for="lastname">Apellidos</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="lastname" uppercaseInput />
            </div>
          </div>
          <div class="col-md-12">
            <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
              <input type="text" class="form-control" formControlName="rut" uppercaseInput
                (keyup)="onFormatRut($event)" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="small mb-1" for="rut">ESTADO</label>
            <div class="input-group">
              <select class="form-select" formControlName="state_id">
                <option *ngFor="let item of items" [value]="item.id">{{item.tag}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <label class="small mb-1" for="date_in">AUTORIZAR EL INGRESO</label>
            <div class="input-group">
                <input type="date" class="form-control" formControlName="date_ing" />
              </div>
          </div>
        </div>
        <button class="btn btn-primary w-100" type="submit">GUARDAR CAMBIOS</button>
      </div>
    </div>
  </form>